import "./ArticleList.scss";
import ContentCard from "components/Cards/ContentCard";
import P from "components/Typography/P";
import useSelector from "hooks/useSelector";
import React from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { onOpenContentItem } from "utils/route";
import { ContentItem } from "api-client";

const ArticleList = () => {
    const { categorySlug, sectionSlug } = useParams<{
        categorySlug: string;
        sectionSlug: string;
    }>();
    const intl = useIntl();
    const zendeskKnowledge = useSelector((state) => state.zendeskKnowledge);
    const selectedSection = zendeskKnowledge.data?.categories
        .find((category) => category.slug === categorySlug)
        ?.sections?.find((section) => section.slug === sectionSlug);
    const uniqueArticles: ContentItem[] = Object.values(
        (selectedSection?.articles ?? []).reduce((acc, obj) => ({ ...acc, [obj.id]: obj }), {}));

    return (
        <div>
            <div className="articles-list-container">
                {selectedSection && (
                    <div>
                        <P className="text__articles_found">
                            {selectedSection.articles?.length}
                            {intl.formatMessage({
                                id: "collection_page.section.result_found",
                            })}
                        </P>
                    </div>
                )}
                <ul className="list">
                    {uniqueArticles?.map((article, i: number) => {
                        return (
                            <li className="list__item" key={`${article.id}-${i}`}>
                                <ContentCard
                                    onClick={() => onOpenContentItem(article.id)}
                                    title={article.title}
                                    tags={article.labelNames || []}
                                    coverImage={article.coverImage!}
                                />
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export default ArticleList;
